import ipaddr from "ipaddr.js";

/**
 * マルチキャストアドレスではないことを確認する
 * @see {@link https://www.infraexpert.com/study/multicastz03.html}
 *
 * チェック内容:
 *   サブネット無しのIPの場合 → マルチキャストアドレス（224.0.0.0/4）ではないことを確認
 *   サブネット付きのIPの場合 → マルチキャストアドレス（224.0.0.0/4）以外のアドレスがないことを確認
 */
export default {
  validate: function (value: string | null | undefined): boolean {
    if (!value) return true;

    let ipV4: ipaddr.IPv4 | [ipaddr.IPv4, number];
    try {
      if (value.indexOf("/") !== -1) {
        ipV4 = ipaddr.IPv4.parseCIDR(value);
      } else {
        ipV4 = ipaddr.IPv4.parse(value);
      }
    } catch (e) {
      return true;
    }
    // サブネット付きのIPの場合
    if (Array.isArray(ipV4)) {
      // マルチキャストアドレス以外のアドレスがないことを確認
      return !(
        ipaddr.IPv4.networkAddressFromCIDR(value).range() === "multicast" &&
        ipaddr.IPv4.broadcastAddressFromCIDR(value).range() === "multicast"
      );
    } else {
      // サブネット無しのIPの場合 → マルチキャストアドレスではないことを確認
      return ipV4.range() !== "multicast";
    }
  },
};
